// extracted by mini-css-extract-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1__cd83a286725d87b76e8b","cls2":"RecommendedPodcastBadge-cls2___fb8275d673b3a770d52 RecommendedPodcastBadge-cls1__cd83a286725d87b76e8b"};